import { HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { CityService } from '@isl-core/services/city.service'

export const HeaderInterceptor: HttpInterceptorFn = (req, next) => {
    const cityService = inject(CityService)
    const newHeaders = {
        setHeaders: { 'X-Isl-site': cityService.get()() }
    }

    const newReq = req.clone(newHeaders)
    return next(newReq)
}
